const optionalString = (v) => v === null || typeof v === 'string';
export function isAdminMemberProfileResponse(value) {
    if (!value || typeof value !== 'object')
        return false;
    const p = value.profile;
    return Boolean(p &&
        typeof p.memberId === 'string' &&
        /^\d{6,20}$/.test(p.nationalId) &&
        typeof p.givenNames === 'string' &&
        typeof p.familyNames === 'string' &&
        (p.status === 'active' || p.status === 'inactive') &&
        Number.isInteger(p.memberVersion) &&
        p.memberVersion > 0 &&
        Number.isInteger(p.profileVersion) &&
        p.profileVersion > 0 &&
        optionalString(p.memberNumber) &&
        optionalString(p.birthDate) &&
        optionalString(p.civilStatusOptionId) &&
        optionalString(p.educationLevelOptionId) &&
        optionalString(p.educationInstitutionTypeOptionId) &&
        optionalString(p.email) &&
        optionalString(p.primaryPhone) &&
        optionalString(p.secondaryPhone) &&
        p.completeness &&
        typeof p.completeness.identity === 'boolean' &&
        typeof p.completeness.personal === 'boolean' &&
        typeof p.completeness.education === 'boolean' &&
        typeof p.completeness.contact === 'boolean');
}
export function isMemberProfileCatalogsResponse(value) {
    const catalogs = value && typeof value === 'object'
        ? value.catalogs
        : null;
    return (Array.isArray(catalogs) &&
        catalogs.every((c) => typeof c.code === 'string' &&
            Array.isArray(c.options) &&
            c.options.every((o) => Boolean(o &&
                typeof o === 'object' &&
                typeof o.id === 'string' &&
                typeof o.code === 'string' &&
                typeof o.label === 'string'))));
}
